<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { DialogTitle } from 'reka-ui'
  import { cn } from '../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <DialogTitle
    as="h3"
    :class="
      cn(
        'flex w-full items-center gap-3 text-lg font-semibold leading-5',
        props.class
      )
    "
  >
    <slot />
  </DialogTitle>
</template>
